/**
 * Hero ASK Pro — Antistatik
 * - Parallax souris subtil sur la vidéo
 * - Recalcule les delays du rotator selon le nombre de phrases
 */
(function () {
  'use strict';
  if (window.__askHeroProReady) return;
  window.__askHeroProReady = true;

  function init() {
    const heros = document.querySelectorAll('[data-hero]');
    heros.forEach(setupHero);
  }

  function setupHero(hero) {
    setupRotator(hero);
    setupParallax(hero);
    setupScrollIndicator(hero);
  }

  /* ─── SCROLL INDICATOR : scroll vers la section suivante ─── */
  function setupScrollIndicator(hero) {
    const arrow = hero.querySelector('.hask-hero__scroll');
    if (!arrow) return;
    arrow.addEventListener('click', function (e) {
      e.preventDefault();
      // Trouve la section qui suit le hero
      let next = hero.nextElementSibling;
      while (next && (next.tagName !== 'SECTION' && !next.querySelector('section'))) {
        next = next.nextElementSibling;
      }
      const target = next || hero.parentElement && hero.parentElement.nextElementSibling;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Fallback : scroll d'une viewport vers le bas
        window.scrollTo({ top: hero.offsetTop + hero.offsetHeight, behavior: 'smooth' });
      }
    });
  }

  /* ─── ROTATOR : recalcule animation-delay selon nb d'items ─── */
  function setupRotator(hero) {
    const items = hero.querySelectorAll('.hask-hero__rotator-item');
    if (items.length === 0) return;
    const total = items.length;
    const perItem = 12 / total; // 12s = durée de la boucle CSS (.hask-rot)
    items.forEach((item, i) => {
      item.style.animationDelay = (i * perItem) + 's';
      // Ajuste les keyframes via percentages dynamiques en utilisant CSS variables
      item.style.setProperty('--rot-duration', (12) + 's');
    });
    // Override la durée en injectant un keyframes adapté
    if (total !== 4) {
      const styleId = 'hask-rot-style-' + (hero.id || 'def');
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        const visiblePct = (100 / total);
        // 6% gap pour transitions
        style.textContent = `
          #${hero.id} .hask-hero__rotator-item {
            animation-duration: ${total * 3}s;
          }
        `;
        document.head.appendChild(style);
      }
    }
  }

  /* ─── PARALLAX SOURIS SUBTIL ─── */
  function setupParallax(hero) {
    if (window.matchMedia('(hover: none)').matches) return; // pas sur mobile
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const video = hero.querySelector('[data-hero-video] video, [data-hero-video] img');
    if (!video) return;
    let raf = false;
    let tx = 0, ty = 0;

    function onMove(e) {
      const rect = hero.getBoundingClientRect();
      const cx = (e.clientX - rect.left) / rect.width;  // 0..1
      const cy = (e.clientY - rect.top) / rect.height;  // 0..1
      tx = (cx - 0.5) * 14;  // max ±7px
      ty = (cy - 0.5) * 10;  // max ±5px
      if (!raf) { raf = true; requestAnimationFrame(apply); }
    }
    function apply() {
      raf = false;
      video.style.transform = `translate(${tx.toFixed(2)}px, ${ty.toFixed(2)}px) scale(1.05)`;
    }
    function onLeave() {
      tx = 0; ty = 0;
      if (!raf) { raf = true; requestAnimationFrame(apply); }
    }

    video.style.transform = 'scale(1.05)'; // léger zoom pour absorber le déplacement
    hero.addEventListener('mousemove', onMove);
    hero.addEventListener('mouseleave', onLeave);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
